<template>
  <div
    class="field-container"
    v-bind:class="{ 'parent-container': parentContainer }"
  >
    <div
      class="field-title"
      v-bind:class="{ 'parent-container': parentContainer }"
    >
      {{ title }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    title: String,
    parentContainer: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';

.field-container {
  margin: 1.75rem 1.5rem 1.75rem 0;
  &.parent-container {
    height: 100%;
    margin: 1.75 0 2.5rem 0.5rem;
  }
}

div.field-title {
  color: $blue;
  font-family: Roboto;
  font-size: 11.2px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 1rem;
  text-transform: uppercase;
  &.parent-container {
    margin-bottom: 2rem;
  }
}
</style>
